export enum CARLINE_BRAND_NDPS {
	VOLKSWAGEN = 'Volkswagen',
	VOLKSWAGEN_COMERCIALES = 'Volkswagen CV',
}

export enum FUEL_TYPE_NDPS {
	COMBUSTION = 'Combustion',
	ELECTRIC = 'Electric',
	HYBRID = 'Hybrid',
	UNDEFINED = 'Undefined',
}

export enum FUEL_TYPE_DATA {
	GASOLINA = 'Gasolina',
	HIBRIDO_ECO = 'Gasolina mild Hybrid (etiqueta ECO)',
	HIBRIDO = 'Híbrido',
	HIBRIDO_ENCHUFABLE = 'Híbrido enchufable',
	ELECTRICO = 'Eléctrico',
	DIESEL = 'Diésel',
}

export enum NEW_OR_USED_CAR_NDPS {
	NEW_CAR = 'New Car',
	USED_CAR = 'Used Car',
}
